import { defineMessages } from 'react-intl';

export const mobileAppHeaderMessages = defineMessages({
  openNavigationMenu: {
    defaultMessage: 'Open navigation menu',
    id: 'G0y7HCXhhm',
    description: 'Accessibility label for opening the mobile navigation menu',
  },
  newChat: {
    defaultMessage: 'New chat',
    id: 'NMHGJBM3uE',
    description: 'Accessibility label for starting a new chat',
  },
  chatHistory: {
    defaultMessage: 'Chat History',
    id: 'DF7zJ99Z/Q',
    description: 'Title and accessibility label for the chat history drawer',
  },
});
